module.exports = __webpack_public_path__ + "img/BackgroundCareCircle.07539690.png";